/**
 * wire-sketch entry. The design system is one file on the page and one
 * global on the window; every desk (app, comments, paywall) attaches
 * its own chrome. See DESIGN notes in the repo if the maps survived.
 */

import * as core from "./core";
import * as packs from "./decoy-packs";
import {
  wireArrow,
  wireBadge,
  wireButton,
  wireCard,
  wireCheckbox,
  wireCircle,
  wireDivider,
  wireHighlight,
  wireInput,
  wireList,
  wireRadio,
  wireSelect,
  wireTextarea,
  wireToggle,
  wireUnderline,
  type AttachOpts,
  type ButtonState,
  type Sketch,
} from "./attach";
import { ensureStyles } from "./svg";

export {
  wireArrow,
  wireBadge,
  wireButton,
  wireCard,
  wireCheckbox,
  wireCircle,
  wireDivider,
  wireHighlight,
  wireInput,
  wireList,
  wireRadio,
  wireSelect,
  wireTextarea,
  wireToggle,
  wireUnderline,
  ensureStyles,
  core,
  packs,
};
export type { AttachOpts, ButtonState, Sketch };

const api = {
  wireArrow,
  wireBadge,
  wireButton,
  wireCard,
  wireCheckbox,
  wireCircle,
  wireDivider,
  wireHighlight,
  wireInput,
  wireList,
  wireRadio,
  wireSelect,
  wireTextarea,
  wireToggle,
  wireUnderline,
  ensureStyles,
  core,
  packs,
};

declare global {
  interface Window {
    WireSketch?: typeof api;
  }
}

if (typeof window !== "undefined") {
  window.WireSketch = api;
}
